import { render, staticRenderFns } from "./NLPost.vue?vue&type=template&id=6e101855&"
import script from "./NLPost.vue?vue&type=script&lang=js&"
export * from "./NLPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports